module.exports = __webpack_public_path__ + "static/media/medellin-10.278bf0ec.jpg";